// The type of a property in the properties stream
/// </summary>
export var PropertyType;
(function (PropertyType) {
    // Any= this property type value matches any type; a server MUST return the actual type in its response. Servers
    // MUST NOT return this type in response to a client request other than NspiGetIDsFromNames or the
    // RopGetPropertyIdsFromNamesROP request ([MS-OXCROPS] section 2.2.8.1). (PT_UNSPECIFIED)
    PropertyType[PropertyType["PT_UNSPECIFIED"] = 0] = "PT_UNSPECIFIED";
    // None= This property is a placeholder. (PT_NULL)
    PropertyType[PropertyType["PT_NULL"] = 1] = "PT_NULL";
    // 2 bytes; a 16-bit integer (PT_I2, i2, ui2)
    PropertyType[PropertyType["PT_SHORT"] = 2] = "PT_SHORT";
    // 4 bytes; a 32-bit integer (PT_LONG, PT_I4, int, ui4)
    PropertyType[PropertyType["PT_LONG"] = 3] = "PT_LONG";
    // 4 bytes; a 32-bit floating point number (PT_FLOAT, PT_R4, float, r4)
    PropertyType[PropertyType["PT_FLOAT"] = 4] = "PT_FLOAT";
    // 8 bytes; a 64-bit floating point number (PT_DOUBLE, PT_R8, r8)
    PropertyType[PropertyType["PT_DOUBLE"] = 5] = "PT_DOUBLE";
    // 8 bytes; a 64-bit floating point number in which the whole number part represents the number of days since
    // December 30, 1899, and the fractional part represents the fraction of a day since midnight (PT_APPTIME)
    PropertyType[PropertyType["PT_APPTIME"] = 7] = "PT_APPTIME";
    // 4 bytes; a 32-bit integer encoding error information as specified in section 2.4.1. (PT_ERROR)
    PropertyType[PropertyType["PT_ERROR"] = 10] = "PT_ERROR";
    // 1 byte; restricted to 1 or 0 (PT_BOOLEAN. bool)
    PropertyType[PropertyType["PT_BOOLEAN"] = 11] = "PT_BOOLEAN";
    // The property value is a Component Object Model (COM) object, as specified in section 2.11.1.5. (PT_OBJECT)
    PropertyType[PropertyType["PT_OBJECT"] = 13] = "PT_OBJECT";
    // 8 bytes; a 64-bit integer (PT_LONGLONG, PT_I8, i8, ui8)
    PropertyType[PropertyType["PT_I8"] = 20] = "PT_I8";
    // 8 bytes; a 64-bit integer (PT_LONGLONG, PT_I8, i8, ui8)
    PropertyType[PropertyType["PT_LONGLONG"] = 20] = "PT_LONGLONG";
    // Variable size; a string of Unicode characters in UTF-16LE format encoding with terminating null character
    // (0x0000). (PT_UNICODE, string)
    PropertyType[PropertyType["PT_UNICODE"] = 31] = "PT_UNICODE";
    // Variable size; a string of multibyte characters in externally specified encoding with terminating null
    // character (single 0 byte). (PT_STRING8) ... ANSI format
    PropertyType[PropertyType["PT_STRING8"] = 30] = "PT_STRING8";
    // 8 bytes; a 64-bit integer representing the number of 100-nanosecond intervals since January 1, 1601
    // (PT_SYSTIME, time, datetime, datetime.tz, datetime.rfc1123, Date, time, time.tz)
    PropertyType[PropertyType["PT_SYSTIME"] = 64] = "PT_SYSTIME";
    // 16 bytes; a GUID with Data1, Data2, and Data3 fields in little-endian format (PT_CLSID, UUID)
    PropertyType[PropertyType["PT_CLSID"] = 72] = "PT_CLSID";
    // Variable size; a 16-bit COUNT field followed by a structure as specified in section 2.11.1.4. (PT_SVREID)
    PropertyType[PropertyType["PT_SVREID"] = 251] = "PT_SVREID";
    // Variable size; a byte array representing one or more Restriction structures as specified in section 2.12.
    // (PT_SRESTRICT)
    PropertyType[PropertyType["PT_SRESTRICT"] = 253] = "PT_SRESTRICT";
    // Variable size; a 16-bit COUNT field followed by that many rule (4) action (3) structures, as specified in
    // [MS-OXORULE] section 2.2.5. (PT_ACTIONS)
    PropertyType[PropertyType["PT_ACTIONS"] = 254] = "PT_ACTIONS";
    // Variable size; a COUNT field followed by that many bytes. (PT_BINARY)
    PropertyType[PropertyType["PT_BINARY"] = 258] = "PT_BINARY";
    // Variable size; a COUNT field followed by that many PT_MV_SHORT values. (PT_MV_SHORT, PT_MV_I2, mv.i2)
    PropertyType[PropertyType["PT_MV_SHORT"] = 4098] = "PT_MV_SHORT";
    // Variable size; a COUNT field followed by that many PT_MV_LONG values. (PT_MV_LONG, PT_MV_I4, mv.i4)
    PropertyType[PropertyType["PT_MV_LONG"] = 4099] = "PT_MV_LONG";
    // Variable size; a COUNT field followed by that many PT_MV_FLOAT values. (PT_MV_FLOAT, PT_MV_R4, mv.float)
    PropertyType[PropertyType["PT_MV_FLOAT"] = 4100] = "PT_MV_FLOAT";
    // Variable size; a COUNT field followed by that many PT_MV_DOUBLE values. (PT_MV_DOUBLE, PT_MV_R8)
    PropertyType[PropertyType["PT_MV_DOUBLE"] = 4101] = "PT_MV_DOUBLE";
    // Variable size; a COUNT field followed by that many PT_MV_CURRENCY values. (PT_MV_CURRENCY, mv.fixed.14.4)
    PropertyType[PropertyType["PT_MV_CURRENCY"] = 4102] = "PT_MV_CURRENCY";
    // Variable size; a COUNT field followed by that many PT_MV_APPTIME values. (PT_MV_APPTIME)
    PropertyType[PropertyType["PT_MV_APPTIME"] = 4103] = "PT_MV_APPTIME";
    // Variable size; a COUNT field followed by that many PT_MV_LONGLONGvalues. (PT_MV_I8, PT_MV_I8)
    PropertyType[PropertyType["PT_MV_LONGLONG"] = 4116] = "PT_MV_LONGLONG";
    // Variable size; a COUNT field followed by that many PT_MV_UNICODE values. (PT_MV_UNICODE)
    PropertyType[PropertyType["PT_MV_TSTRING"] = 4127] = "PT_MV_TSTRING";
    // Variable size; a COUNT field followed by that many PT_MV_UNICODE values. (PT_MV_UNICODE)
    PropertyType[PropertyType["PT_MV_UNICODE"] = 4127] = "PT_MV_UNICODE";
    // Variable size; a COUNT field followed by that many PT_MV_STRING8 values. (PT_MV_STRING8, mv.string)
    PropertyType[PropertyType["PT_MV_STRING8"] = 4126] = "PT_MV_STRING8";
    // Variable size; a COUNT field followed by that many PT_MV_SYSTIME values. (PT_MV_SYSTIME)
    PropertyType[PropertyType["PT_MV_SYSTIME"] = 4160] = "PT_MV_SYSTIME";
    // Variable size; a COUNT field followed by that many PT_MV_CLSID values. (PT_MV_CLSID, mv.uuid)
    PropertyType[PropertyType["PT_MV_CLSID"] = 4168] = "PT_MV_CLSID";
    // Variable size; a COUNT field followed by that many PT_MV_BINARY values. (PT_MV_BINARY, mv.bin.hex)
    PropertyType[PropertyType["PT_MV_BINARY"] = 4354] = "PT_MV_BINARY";
})(PropertyType || (PropertyType = {}));
export var MessageEditorFormat;
(function (MessageEditorFormat) {
    // The format for the editor to use is unknown.
    MessageEditorFormat[MessageEditorFormat["EDITOR_FORMAT_DONTKNOW"] = 0] = "EDITOR_FORMAT_DONTKNOW";
    // The editor should display the message in plain text format.
    MessageEditorFormat[MessageEditorFormat["EDITOR_FORMAT_PLAINTEXT"] = 1] = "EDITOR_FORMAT_PLAINTEXT";
    // The editor should display the message in HTML format.
    MessageEditorFormat[MessageEditorFormat["EDITOR_FORMAT_HTML"] = 2] = "EDITOR_FORMAT_HTML";
    // The editor should display the message in Rich Text Format.
    MessageEditorFormat[MessageEditorFormat["EDITOR_FORMAT_RTF"] = 3] = "EDITOR_FORMAT_RTF";
})(MessageEditorFormat || (MessageEditorFormat = {}));
export var AttachmentType;
(function (AttachmentType) {
    // There is no attachment
    AttachmentType[AttachmentType["NO_ATTACHMENT"] = 0] = "NO_ATTACHMENT";
    // The  PropertyTags.PR_ATTACH_DATA_BIN property contains the attachment data
    AttachmentType[AttachmentType["ATTACH_BY_VALUE"] = 1] = "ATTACH_BY_VALUE";
    // The "PropertyTags.PR_ATTACH_PATHNAME_W" or "PropertyTags.PR_ATTACH_LONG_PATHNAME_W"
    // property contains a fully qualified path identifying the attachment to recipients with access to a common file server
    AttachmentType[AttachmentType["ATTACH_BY_REFERENCE"] = 2] = "ATTACH_BY_REFERENCE";
    // The "PropertyTags.PR_ATTACH_PATHNAME_W" or "PropertyTags.PR_ATTACH_LONG_PATHNAME_W"
    // property contains a fully qualified path identifying the attachment
    AttachmentType[AttachmentType["ATTACH_BY_REF_RESOLVE"] = 3] = "ATTACH_BY_REF_RESOLVE";
    // The "PropertyTags.PR_ATTACH_PATHNAME_W" or "PropertyTags.PR_ATTACH_LONG_PATHNAME_W"
    // property contains a fully qualified path identifying the attachment
    AttachmentType[AttachmentType["ATTACH_BY_REF_ONLY"] = 4] = "ATTACH_BY_REF_ONLY";
    // The "PropertyTags.PR_ATTACH_DATA_OBJ" (PidTagAttachDataObject) property contains an embedded object
    // that supports the IMessage interface
    AttachmentType[AttachmentType["ATTACH_EMBEDDED_MSG"] = 5] = "ATTACH_EMBEDDED_MSG";
    // The attachment is an embedded OLE object
    AttachmentType[AttachmentType["ATTACH_OLE"] = 6] = "ATTACH_OLE";
})(AttachmentType || (AttachmentType = {}));
export const StoreSupportMaskConst = 32 /* StoreSupportMask.STORE_ATTACH_OK */ | // | StoreSupportMask.STORE_CATEGORIZE_OK
 16 /* StoreSupportMask.STORE_CREATE_OK */ | //StoreSupportMask.STORE_ENTRYID_UNIQUE
 8 /* StoreSupportMask.STORE_MODIFY_OK */ | // | StoreSupportMask.STORE_MV_PROPS_OK
 65536 /* StoreSupportMask.STORE_HTML_OK */ | 262144 /* StoreSupportMask.STORE_UNICODE_OK */;
export var ContentTransferEncoding;
(function (ContentTransferEncoding) {
    ContentTransferEncoding["SevenBit"] = "7bit";
    ContentTransferEncoding["EightBit"] = "8bit";
    ContentTransferEncoding["QuotedPrintable"] = "quoted-printable";
    ContentTransferEncoding["Base64"] = "base64";
    ContentTransferEncoding["Binary"] = "binary";
})(ContentTransferEncoding || (ContentTransferEncoding = {}));
